'use client';
import { checkCookieYesConsent } from '@bw/core';
import { AgencyDetails } from '@bw/external-apis/shared';
import { Asset } from 'contentful';
import { setCookie } from 'cookies-next';
import { FC, useEffect } from 'react';
import { Header } from '../../header/header';
import { buildHeaderData } from './buildHeaderData';

export const AgencyHeader: FC<{
	agencyDetails: AgencyDetails;
	insuranceTypeId?: string;
	loginUrl: string;
	lockupImage?: Asset<'WITHOUT_UNRESOLVABLE_LINKS'>;
}> = ({ agencyDetails, insuranceTypeId, loginUrl, lockupImage }) => {
	useEffect(() => {
		if (insuranceTypeId && typeof localStorage !== 'undefined') {
			localStorage.setItem('leadInsuranceTypeId', insuranceTypeId);
		}
		if (typeof localStorage !== 'undefined') {
			localStorage.setItem('storeNumber', agencyDetails.agency.storeNumber);
		}
		if (
			checkCookieYesConsent('consent') &&
			checkCookieYesConsent('functional')
		) {
			setCookie('visitedAgentId', agencyDetails.agency.id);
		}
	}, []);

	const stateAbbrForUrl = agencyDetails.agency.stateAbbreviation.toLowerCase();

	const data = buildHeaderData(agencyDetails, stateAbbrForUrl, loginUrl, lockupImage);

	return <Header entry={data} isLockup={!!lockupImage} />;
};
